import { render, staticRenderFns } from "./MiddleBanner.vue?vue&type=template&id=4f980d6e&scoped=true&"
import script from "./MiddleBanner.vue?vue&type=script&lang=js&"
export * from "./MiddleBanner.vue?vue&type=script&lang=js&"
import style0 from "./MiddleBanner.vue?vue&type=style&index=0&id=4f980d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f980d6e",
  null
  
)

export default component.exports